/**
 * /tenants/$slug/agents/protected-resources — Protected resources (AI Agents →
 * Agent governance). Tenant-wide no-bypass posture, moved off the registry list (§5b).
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchResourcePosture } from "@/features/agents/queries";
import { queryKeys } from "@/lib/query-keys";
import { AgentProtectedResourcesPage } from "@/features/agents/pages/agent-protected-resources-page";
import { protectedResourceSetupSearchSchema } from "@/features/agents/schemas";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/protected-resources")({
  validateSearch: protectedResourceSetupSearchSchema,
  // Prefetch so the posture grid is warm on navigation (sibling-route idiom).
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.protectedResources(context.tenant.id),
      queryFn: () => fetchResourcePosture(context.tenant.id),
    }),
  component: AgentProtectedResourcesPage,
});
